import esContent from './backup.es';

export default {
  ...esContent,
};
